export const ai = {
  title: 'مدرسك اللغوي المتخصص',
  description: 'تعلم اللغات بطريقة تفاعلية مع مدرس شخصي يتكيف مع مستواك وأهدافك',
  startChat: 'ابدأ المحادثة',
  selectLanguage: 'اختر لغة التعلم',
  languageDescription: 'اختر اللغة التي تريد إتقانها وابدأ رحلة التعلم معنا'
};